const FAVORITE_CATEGORIES = {
  TEAM: "teams",
  MATCH: "matches",
  LEAGUE: "leagues",
  PLAYER: "players"
};
export {
  FAVORITE_CATEGORIES
};
